import { View } from "@/components/ui";
import {
  ClipboardText,
  BellSimple,
  CreditCard,
  FileText,
  ShieldCheck,
  SquaresFour,
  User,
  Users,
} from "@/components/shared/icons";
import { Divider } from "../divider";
import { ROUTES } from "@/constants/routes";
import { useLocation } from "react-router-dom";
import { useSegments } from "@/components/hooks/use-segments";
import {
  useGetPaymentPath,
  useGetProfilePath,
  useGetReferralPath,
} from "./lib";
import { Typography } from "../typography";
import { links } from "@/constants";
import { onChatSupport } from "@/lib/chat-support";
import { WhatsappSupportBanner } from "../whatsapp-support-banner";
import { SideNavbarListItem } from "./side-navbar-list-item";
import { SideNavbarListItemInvoice } from "./side-navbar-list-item-invoice";

export const SideNavbar = () => {
  const segments = useSegments();
  const profilePath = segments.at(-1);
  const { pathname } = useLocation();
  const { isInsideAccountInfo, isInsideOverview } = useGetProfilePath(
    profilePath ?? "",
    pathname,
  );
  const { isInsideAccountMyReferral } = useGetReferralPath(pathname);
  const { paymentRoute } = useGetPaymentPath();
  return (
    <View className="SideNavbar relative w-full">
      <View className="flex flex-col gap-3 rounded-lg border bg-white p-4">
        <View className="flex flex-col gap-2">
          <Typography variant="body-sm" color="foreground-intermediate">
            Account &amp; Settings
          </Typography>
          <SideNavbarListItem
            title="Overview"
            icon={SquaresFour}
            active={isInsideOverview}
            to={ROUTES.Profile.Children.Overview}
          />
          <SideNavbarListItem
            title="Account Info"
            icon={User}
            active={isInsideAccountInfo}
            to={ROUTES.Profile.Children.AccountInfo}
          />
          <SideNavbarListItem
            title="Services Profile"
            icon={ClipboardText}
            active={
              !!segments.includes(ROUTES.Profile.Children.ServiceProfile.Root)
            }
            to={ROUTES.Profile.Children.ServiceProfile.Root}
          />
          <SideNavbarListItem
            title="Notification Settings"
            icon={BellSimple}
            active={
              profilePath === ROUTES.Profile.Children.NotificationSettings
            }
            to={ROUTES.Profile.Children.NotificationSettings}
          />
        </View>
        <Divider />
        <View className="flex flex-col gap-2">
          <Typography variant="body-sm" color="foreground-intermediate">
            Billing
          </Typography>
          <SideNavbarListItemInvoice />
          <SideNavbarListItem
            title="Payment"
            icon={CreditCard}
            active={
              profilePath === ROUTES.Profile.Children.Payment ||
              profilePath === ROUTES.Profile.Children.AddCreditCard
            }
            to={paymentRoute}
          />
        </View>
        <Divider />
        <View className="flex flex-col gap-2">
          <Typography variant="body-sm" color="foreground-intermediate">
            Other Info
          </Typography>
          <SideNavbarListItem
            title="My Referral"
            icon={Users}
            active={isInsideAccountMyReferral}
            to={ROUTES.Profile.Children.AccountMyReferral}
          />
          <SideNavbarListItem
            title="Terms of Services"
            icon={FileText}
            to={links.legalTermCondition}
            external
          />
          <SideNavbarListItem
            title="Privacy Policy"
            icon={ShieldCheck}
            to={links.legalPrivacyPolicy}
            external
          />
        </View>
      </View>
      <View className="mt-2">
        <WhatsappSupportBanner onClick={() => onChatSupport()} />
      </View>
    </View>
  );
};
